import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../../lib/api';
import { Logo } from '../../components/ui/logo';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';

/**
 * „Passwort vergessen?“ im Office (T-0131). Der Link auf der Anmeldeseite zeigte
 * auf eine Seite, die es nicht gab — man landete wieder auf dem Login.
 */
const PasswortVergessen = () => {
  const [email, setEmail] = useState('');
  const [gesendet, setGesendet] = useState(false);
  const [laeuft, setLaeuft] = useState(false);
  const [fehler, setFehler] = useState('');

  const absenden = async (e: React.FormEvent) => {
    e.preventDefault();
    setFehler('');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setFehler('Bitte gib eine gültige E-Mail-Adresse ein.');
      return;
    }
    setLaeuft(true);
    try {
      await api.post('/api/auth/forgot-password', { email: email.trim() });
      // Ob es das Konto gibt, verrät die Antwort absichtlich nicht.
      setGesendet(true);
    } catch {
      setFehler('Das hat nicht geklappt. Bitte versuche es gleich noch einmal.');
    } finally {
      setLaeuft(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background p-4">
      <div className="w-full max-w-md space-y-8">
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <Logo size="lg" />
          </div>
          <h2 className="mt-2 text-xl font-semibold">Passwort vergessen</h2>
          <p className="mt-2 text-sm text-muted-foreground">
            Gib deine E-Mail-Adresse ein. Wir schicken dir einen Link, mit dem du ein neues Passwort vergibst.
          </p>
        </div>

        {gesendet ? (
          <div className="rounded-md border p-4 text-sm">
            Wenn es zu <span className="font-medium">{email.trim()}</span> ein Konto gibt, ist die E-Mail unterwegs.
            Der Link gilt eine Stunde.
          </div>
        ) : (
          <form className="space-y-6" onSubmit={absenden}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium">
                E-Mail-Adresse
              </label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={fehler ? 'border-destructive' : ''}
              />
              {fehler && <p className="mt-1 text-xs text-destructive">{fehler}</p>}
            </div>
            <Button type="submit" className="w-full" disabled={laeuft}>
              {laeuft ? 'Wird gesendet...' : 'Link anfordern'}
            </Button>
          </form>
        )}

        <div className="text-center text-sm">
          <Link to="/login" className="font-medium text-primary hover:underline">
            Zurück zur Anmeldung
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PasswortVergessen;
